import React from "react";
import { Divider } from "@mui/material";
import { FxMapLatLng } from "./../components/map/FxMap";
import { FxTextField, FxTextField2, FxPassWordTextField } from "./FxTextField";
import { FxTextArea, FxTextArea2 } from "./FxTextArea";
import { FxSelect, FxSelect2 } from "./FxSelect";
import { FxEmail } from "./FxEmail";
import { FxCheckBox, FxCheckBox2 } from "./FxCheckBox";
import { FxDateTime, FxDateTime2 } from "./FxDateTime";
import { FxDate, FxDate2, FxDateMonth, FxEmptyDate } from "./FxDate";
import { FxButton, FxButton2 } from "./FxButton";
import { FxFile, FxFile2 } from "./FxFile";
import { FxTitle } from "./FxTitle";
import { FxLabel } from "./FxLabel";

/**
 * 입력 노드 만들기
 *
 * @param {*} attr
 * @param {*} updateInputData
 * @param {*} onChangeValue
 * @param {*} clickButton
 * @param {*} inputDatas
 * @param {*} inputType
 * @param {*} onButtonRef
 * @param {*} includeLabel
 * @returns
 */
export function FxInput0(
  attr,
  updateInputData,
  onChangeValue,
  clickButton,
  inputDatas,
  inputType,
  onButtonRef,
  includeLabel = true
) {
  const key = "INPUT_" + attr.attrName;

  if (attr.attrTypeCd === "text") {
    return (
      <FxTextField
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
        includeLabel={includeLabel}
      />
    );
  } else if (attr.attrTypeCd === "textarea") {
    return (
      <FxTextArea
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
      />
    );
  } else if (attr.attrTypeCd === "email") {
    return (
      <FxEmail
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
      />
    );
  } else if (attr.attrTypeCd === "date") {
    return (
      <FxDate
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
      />
    );
  } else if (attr.attrTypeCd === "dateMonth") {
    return (
      <FxDateMonth
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
      />
    );
  } else if (attr.attrTypeCd === "datetime") {
    return (
      <FxDateTime
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
      />
    );
  } else if (attr.attrTypeCd === "number") {
    return (
      <FxTextField
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
      />
    );
  } else if (attr.attrTypeCd === "file") {
    return (
      <FxFile
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
      />
    );
  } else if (attr.attrTypeCd === "button") {
    return (
      <FxButton
        key={key}
        attr={attr}
        clickButton={clickButton}
        inputType={inputType}
        onButtonRef={onButtonRef}
      />
    );
  } else if (attr.attrTypeCd === "buttonMap") {
    return (
      <FxMapLatLng
        key={key}
        attr={attr}
        onSelectedLatLng={updateInputData}
        fxInObj={inputDatas}
        refData={attr.etcInfoObj}
      />
    );
  } else if (attr.attrTypeCd === "select") {
    return (
      <FxSelect
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
        inputType={inputType}
      />
    );
  } else if (attr.attrTypeCd === "checkbox") {
    return (
      <FxCheckBox
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
      />
    );
  } else if (attr.attrTypeCd === "boolean") {
    return (
      <FxCheckBox
        key={key}
        attr={attr}
        onChangeValue={onChangeValue}
        fxInObj={inputDatas}
      />
    );
  } else if (attr.attrTypeCd === "label") {
    return <FxLabel key={key} attr={attr} />;
  } else if (attr.attrTypeCd === "title") {
    return <FxTitle key={key} attr={attr} />;
  } else if (attr.attrTypeCd === "separator") {
    return <Divider key={key} />;
  }
}

/**
 *
 * @param {*} props
 * @returns
 */
export const FxInput = (props) => {
  const { attrClass, para } = props;
  const attr = attrClass.getAttr();
  const key = "FxInput_" + attr.attrName;
  const defaultValue = para.selectedData
    ? para.selectedData[attr.attrName]
    : "";

  console.log("*** FxInput ***   props  ", props);
  console.log("*** FxInput ***   defaultValue  ", attr.attrName + "=" + defaultValue);

  if (attr.attrTypeCd === "text") {
    return (
      <FxTextField2
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
      />
    );
  } else if (attr.attrTypeCd === "password") {
    return (
      <FxPassWordTextField
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
        placeholder={"대문자 + 소문자 + 숫자 + 특수문자 8~16자"}
      />
    );
  } else if (attr.attrTypeCd === "currentPassword") {
    return (
      <FxPassWordTextField
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
        placeholder={""}
      />
    );
  } else if (attr.attrTypeCd === "textarea") {
    return (
      <FxTextArea2
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
      />
    );
  } else if (attr.attrTypeCd === "date") {
    return (
      <FxDate2 attrClass={attrClass} para={para} defaultValue={defaultValue} />
    );
  } else if (attr.attrTypeCd === "emptyDate") {
    return (
      <FxEmptyDate attrClass={attrClass} para={para} />
    );
  } else if (attr.attrTypeCd === "datetime") {
    return (
      <FxDateTime2
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
      />
    );
  } else if (attr.attrTypeCd === "select") {
    return (
      <FxSelect2
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
      />
    );
  } else if (attr.attrTypeCd === "number") {
    return (
      <FxTextField2
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
      />
    );
  } else if (attr.attrTypeCd === "file") {
    return (
      <FxFile2 attrClass={attrClass} para={para} defaultValue={defaultValue} />
    );
  } else if (attr.attrTypeCd === "button") {
    return (
      <FxButton2
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
      />
    );
  } else if (attr.attrTypeCd === "checkbox") {
    return (
      <FxCheckBox2
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
      />
    );
  } else {
    return (
      <FxTextField2
        attrClass={attrClass}
        para={para}
        defaultValue={defaultValue}
      />
    );
  }
};
